<template>
    <div class="font-size18 c-969799 xy-center empty">
        {{tips}}
    </div>
</template>

<script>
export default {
    name: "EmptyData",
    props: {
        tips: {
            type: String,
            default: "暂无数据"
        }
    }
}
</script>

<style scoped lang="less">
.empty{
    width: 100%;
    height: 500px;
    background-color: white;
}
</style>
